import { useMutation } from '@tanstack/react-query';
import { authApi } from '../services/authApi';

export interface FeedbackPayload {
  category: 'bug' | 'feature' | 'general' | 'data_quality';
  message: string;
  page_context?: string | undefined;
  search_context?: Record<string, unknown> | undefined;
  /**
   * Base64 data URL of an attached screenshot
   * (``data:image/jpeg;base64,...``). Backend caps decoded size at
   * 6 MB; the captureScreenshot utility downscales + JPEG-compresses
   * to keep output well under that.
   */
  screenshot_data_url?: string | undefined;
}

export interface FeedbackResult {
  id: number;
  category: string;
  message: string;
  status: string;
  created_at: string;
}

export function useFeedbackMutation() {
  return useMutation<FeedbackResult, Error, FeedbackPayload>({
    mutationFn: async (payload) => {
      const response = await authApi.submitFeedback(payload);
      return response as FeedbackResult;
    },
  });
}
